// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.image-container[data-v-e0394d92] {\n  display: grid;\n  justify-content: center;\n  min-height: 100px;\n}\n.placeholder-container[data-v-e0394d92] {\n  display: grid;\n  justify-content: center;\n  align-content: center;\n  height: 100px;\n  padding: 15px;\n  margin: auto;\n  text-align: center;\n  border: 1px solid #eee;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
